import {validateValue} from '../helpers/validation'

// Begin action types
export const SET_CLIENTREQUEST_SEARCH_DROPDOWN_OPTIONS = 'SET_CLIENTREQUEST_SEARCH_DROPDOWN_OPTIONS'
export const CLEAR_CLIENTREQUEST_SEARCH_FIELDS = 'CLEAR_CLIENTREQUEST_SEARCH_FIELDS'
export const VALIDATE_CLIENTREQUEST_SEARCH_FIELD = 'VALIDATE_CLIENTREQUEST_SEARCH_FIELD'

export const SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_CLIENTS = 'SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_CLIENTS'
export const SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_COUTRIES = 'SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_COUTRIES'
export const CLEAR_CLIENTACCOUNT_SEARCH_FIELDS = 'CLEAR_CLIENTACCOUNT_SEARCH_FIELDS'
export const VALIDATE_CLIENTACCOUNT_SEARCH_FIELD = 'VALIDATE_CLIENTACCOUNT_SEARCH_FIELD'

export const SET_CLIENTREQUEST_EDIT_LOAD_FIELDS = 'SET_CLIENTREQUEST_EDIT_LOAD_FIELDS'
export const CLEAR_CLIENTREQUEST_EDIT_FIELDS = 'CLEAR_CLIENTREQUEST_EDIT_FIELDS'
export const VALIDATE_CLIENTREQUEST_EDIT_FIELD = 'VALIDATE_CLIENTREQUEST_EDIT_FIELD'
export const SUBMIT_CLIENTREQUEST_EDIT_FIELDS = 'SUBMIT_CLIENTREQUEST_EDIT_FIELDS'
// End action types


// request search
export const setClientRequestSearchDropdownOptions = (productionContentOwners) => ({
	type: SET_CLIENTREQUEST_SEARCH_DROPDOWN_OPTIONS,
	productionContentOwners
});

export const clearClientRequestSearchFields = () => ({
	type: CLEAR_CLIENTREQUEST_SEARCH_FIELDS
});

export const validateClientRequestSearchField = (value, field) => {
	field = validateValue(value, field);
	return {
		type: VALIDATE_CLIENTREQUEST_SEARCH_FIELD,
		field
	}
}

// account search
export const setClientAccountSearchDropdownOptionsClients = (productionContentOwners) => ({
	type: SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_CLIENTS,
	productionContentOwners
});

export const setClientAccountSearchDropdownOptionsCountry = (countries) => ({
	type: SET_CLIENTACCOUNT_SEARCH_DROPDOWN_OPTIONS_COUTRIES,
	countries
});

export const clearClientAccountSearchFields = () => ({
	type: CLEAR_CLIENTACCOUNT_SEARCH_FIELDS
});

export const validateClientAccountSearchField = (value, field) => {
	field = validateValue(value, field);
	return {
		type: VALIDATE_CLIENTACCOUNT_SEARCH_FIELD,
		field
	}
}

// edit
export const setClientRequestEditLoadFields = (data) => ({
	type: SET_CLIENTREQUEST_EDIT_LOAD_FIELDS,
	data
});

export const clearClientRequestEditFields = () => ({
	type: CLEAR_CLIENTREQUEST_EDIT_FIELDS
});

export const validateClientRequestEditField = (value, field) => {
	field = validateValue(value, field);
	return {
		type: VALIDATE_CLIENTREQUEST_EDIT_FIELD,
		field
	}
}
export const submitClientRequestEditFields = (fields) => {
	return {
	  type: SUBMIT_CLIENTREQUEST_EDIT_FIELDS,
	  fields
	}
}